import styled, { css } from 'styled-components'

export const Content = styled.div`
  ${({ templateColumns, gap, mainGap }) => css`
    margin-top: 32px;
    display: flex;
    flex-direction: column;
    gap: ${gap || '26px'};

    header,
    main {
      display: flex;
      flex-direction: column;
      gap: ${mainGap || '1rem'};
      width: 100%;

      ul {
        display: grid;
        grid-template-columns: ${templateColumns ||
        'repeat(auto-fit, minmax(10px, 1fr))'};
        color: var(--text-tertiary);
        gap: 2%;
        min-height: 48px;

        li {
          display: flex;
          align-items: center;
          gap: 10px;
          overflow-wrap: anywhere;

          svg {
            cursor: pointer;
          }

          :nth-child(n + 4):nth-child(-n + 6) {
            justify-content: center;
            text-align: center;
          }
        }

        @media (max-width: 992px) {
          grid-template-columns: 1fr;
          grid-template-rows: repeat(auto-fit, 100px);

          li {
            justify-content: center;
            text-align: center;
            align-items: center;
          }
        }
      }
    }

    header ul li {
      font-size: var(--font-size-sm);
      font-weight: bold;
    }

    main ul li {
      font-size: var(--font-size-sm);
    }

    footer {
      width: 100%;
      display: flex;
      justify-content: center;
      gap: 1rem;
    }
  `}
`
